import ShopifyLink from './shopify-link';

export default ShopifyLink;
